export default function deleteRecord(list, id) {
  let index
  const record = list.find((item, idx) => {
    index = idx
    return item.id === id
  })

  if (record) {
    list.splice(index, 1)
  }
}
